import React, { useEffect, useRef, useState } from "react";
import { Grid, Typography, IconButton, CardMedia } from "@mui/material";
import SvgIcon from "../../components/SvgIcon";
import { injectIntl } from "react-intl";
import {
  commaSeparateFormat,
  customReplaceAll,
  dateFormat,
  downloadReport,
  getOrdinalSuffix,
  getPropertyTypeGroup,
  getPropertyTypeName,
  sendPageView,
  _trackActivity,
  formatFloatValue,
} from "../../resources/utils";
import {
  StyleAlert,
  StyleButtonLarge,
  StyleHeading,
  StyleInfoTypography,
  StyleTooltip,
  StyleTooltipMessage,
  StyleTypography,
  // StyleWhiteCircularProgress,
} from "../../assets/js/Theme";
import Comparables from "./Comparables";
import IndexAndVolume from "./IndexAndVolume";
import AboutProperty from "./AboutProperty";
import SoldProperties from "./SoldProperties";
import {
  APARTMENT_GROUP_ID,
  DEVICE_WIDTH,
  DUBAI,
  IS_MOBILE_WIDTH,
} from "../../resources/Constants";
import { fetchValPriceRange } from "../../crud/avm.crud";
import TermsAndConditions from "./TermsAndConditions";
import Speedometer from "../../assets/images/speedometer.png";

const AvmResult = (props) => {
  const {
    intl,
    overallResults,
    selectedUnit,
    showComparables,
    showCharts,
    showSoldProperties,
    goBack,
    showAbout,
    doUpdate,
    showFeedbackWidget,
    feedbackDone,
    reportHash,
    currentSession,
    currentUser,
    setContext
  } = props;

  const [addressLength, setAddressLength] = useState();
  const [valPriceRange, setValPriceRange] = useState();
  const reportId = overallResults?.reportId || "";

  const [bottomScrollSeen, setBottomScrollSeen] = useState(false);
  // const [downloadReportDisabled, setDownloadReportDisabled] = useState(true);
  const pageHeight = useRef();
  // useEffect(() => {
  //   const handleScroll = () => {
  //     if (pageHeight.current) {
  //       let getScrollBottom =
  //         pageHeight.current.clientHeight - window.pageYOffset;
  //       if (getScrollBottom <= window.innerHeight) {
  //         //show feedback widget modal
  //         if (!feedbackDone && !bottomScrollSeen) {
  //           showFeedbackWidget("result", "bottomScroll");
  //           setBottomScrollSeen(true);
  //           window.scrollTo(0, document.body.scrollHeight);
  //         }
  //       }
  //     }
  //   };
  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, [bottomScrollSeen, feedbackDone, showFeedbackWidget]);
  const delay = 50;//sec
  useEffect(
    () => {
      let timer1 = setTimeout(() => showFeedbackWidget("result", "timer"), delay * 1000);
      return () => {
        clearTimeout(timer1);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );


  useEffect(() => {
    let getAddressLength;
    getAddressLength = overallResults.comparableData.map((a) => a.search_value);
    getAddressLength = Math.max(...getAddressLength.map((el) => el.length));
    setAddressLength(getAddressLength);
  }, [overallResults]);

  useEffect(() => {
    sendPageView("/avm-result");
    setContext('avm-result')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _fetchValPriceRange = async () => {
    try {
      const queryParams = {
        emirateId: DUBAI,
        unitSizeSqft: overallResults?.unitSizeSqft || "",
        plotSizeSqft: overallResults?.plotSizeSqft || "",
        propertyTypeId: overallResults?.propertyTypeId || "",
        locationId: overallResults?.locationId || "",
        bedrooms: overallResults?.bedrooms || "",
        bathrooms: overallResults?.bathrooms || "",
        // reportId,
        reportHash,
      };
      const result = await fetchValPriceRange(queryParams);
      const { status, data } = result.data;
      if (status === 1) {
        setValPriceRange(data);
      } else {
        console.log("data not populated");
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    _fetchValPriceRange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div ref={pageHeight}>
      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          className="section--heading--wrapper report--date--wrapper padding-12"
        >
          <StyleHeading
            color="secondary"
            className="report--date--value"
            variant="h4"
          >
            <strong>{`${intl.formatMessage({
              id: "GENERAL.REPORT_DATE",
            })}: `}</strong>
            {overallResults?.reportDate
              ? dateFormat(overallResults.reportDate)
              : ""}
          </StyleHeading>
          <hr />
          <StyleHeading
            color="secondary"
            className="report--id--value"
            variant="h4"
          >
            <strong>{`${intl.formatMessage({
              id: "GENERAL.REPORT_ID",
            })}: `}</strong>
            {reportId}
          </StyleHeading>
        </Grid>
        <Grid item xs={12} className="padding-12">
          <StyleHeading color="primary" variant="h3">
            {selectedUnit?.property_new_address || ""}
          </StyleHeading>
        </Grid>
      </Grid>
      <Grid
        container
        className="property--info--wrapper"
        alignItems="center"
        justifyContent="flex-start"
        spacing={2}
      >
        <Grid item xs={6} md={"auto"} className="property--info">
          <StyleTooltip
            arrow
            className="property--icon"
            title={intl.formatMessage(
              { id: "GENERAL.PROPERTY_TYPE" },
              { break: "" }
            )}
          >
            <Typography component="span">
              <SvgIcon name="type" />
            </Typography>
          </StyleTooltip>

          <StyleTypography className="property--text">
            {getPropertyTypeName(overallResults.propertyTypeId)}
          </StyleTypography>
        </Grid>
        {overallResults.bedrooms ? (
          <Grid item xs={6} md={"auto"} className="property--info">
            <StyleTooltip
              arrow
              className="property--icon"
              title={intl.formatMessage({ id: "GENERAL.BEDROOM" })}
            >
              <Typography component="span">
                <SvgIcon name="bedroom" />
              </Typography>
            </StyleTooltip>
            <StyleTypography className="property--text">
              {`${overallResults.bedrooms} `}
              {overallResults.bedrooms > 0
                ? `${intl.formatMessage({
                  id: "GENERAL.BED",
                })} `
                : null}

              {overallResults.bathrooms ? (
                <>
                  {intl.formatMessage({
                    id: "GENERAL.AND",
                  })}
                  {` ${overallResults.bathrooms} `}
                  {intl.formatMessage({
                    id: "GENERAL.BATH",
                  })}
                </>
              ) : null}
            </StyleTypography>
          </Grid>
        ) : null}
        {overallResults.unitSizeSqft ? (
          <Grid item xs={6} md={"auto"} className="property--info">
            <StyleTooltip
              arrow
              className="property--icon"
              title={intl.formatMessage({ id: "GENERAL.UNIT_SIZE" })}
            >
              <Typography component="span">
                <SvgIcon name="size" />
              </Typography>
            </StyleTooltip>
            <StyleTypography className="property--text">
              {commaSeparateFormat(overallResults.unitSizeSqft)}
              {` ${intl.formatMessage({
                id: "GENERAL.SQ_FT",
              })}`}
            </StyleTypography>
          </Grid>
        ) : null}
        {overallResults?.plotSizeSqft ? (
          <Grid item xs={6} md={"auto"} className="property--info">
            <StyleTooltip
              arrow
              className="property--icon"
              title={intl.formatMessage({ id: "GENERAL.PLOT_SIZE" })}
            >
              <Typography component="span">
                <SvgIcon name="size" />
              </Typography>
            </StyleTooltip>
            <StyleTypography className="property--text">
              {commaSeparateFormat(overallResults.plotSizeSqft)}
              {` ${intl.formatMessage({
                id: "GENERAL.SQ_FT",
              })}`}
            </StyleTypography>
          </Grid>
        ) : null}
        {overallResults?.floor ? (
          <Grid item xs={6} md={"auto"} className="property--info">
            <StyleTooltip
              arrow
              className="property--icon"
              title={intl.formatMessage({ id: "GENERAL.FLOOR" })}
            >
              <Typography component="span">
                <SvgIcon name="floor" />
              </Typography>
            </StyleTooltip>
            <StyleTypography className="property--text">
              {getPropertyTypeGroup(overallResults?.propertyTypeId) ===
                APARTMENT_GROUP_ID
                ? getOrdinalSuffix(overallResults.floor)
                : customReplaceAll(overallResults.floor, "G ", "G+")}
              {` ${intl.formatMessage({
                id: "GENERAL.FLOOR",
              })}`}
            </StyleTypography>
          </Grid>
        ) : null}
        {selectedUnit?.no_of_parking ? (
          <Grid item xs={6} md={"auto"} className="property--info">
            <StyleTooltip
              arrow
              className="property--icon"
              title={intl.formatMessage({ id: "GENERAL.PARKING" })}
            >
              <Typography component="span">
                <SvgIcon name="parking" />
              </Typography>
            </StyleTooltip>
            <StyleTypography className="property--text">
              {selectedUnit.no_of_parking}
              {` ${intl.formatMessage({
                id: "GENERAL.PARKING",
              })}`}
            </StyleTypography>
          </Grid>
        ) : null}
        {selectedUnit?.developer_name ? (
          <Grid item xs={6} md={"auto"} className="property--info">
            <StyleTooltip
              arrow
              className="property--icon"
              title={intl.formatMessage({ id: "GENERAL.DEVELOPER" })}
            >
              <Typography component="span">
                <SvgIcon name="developer" />
              </Typography>
            </StyleTooltip>
            <StyleTypography className="property--text">
              {selectedUnit.developer_name}
            </StyleTypography>
          </Grid>
        ) : null}
        {overallResults?.totalServiceCharges && overallResults?.annualServiceCharges ? (
          <Grid item xs={6} md={"auto"} className="property--info">
            <StyleTooltip
              arrow
              className="property--icon"
              title={intl.formatMessage({ id: "GENERAL.SERVICE_CHARGES" })}
            >
              <Typography component="span">
                <SvgIcon name="service-charges" />
              </Typography>
            </StyleTooltip>
            <StyleTypography className="property--text">
              {`${intl.formatMessage({
                id: "GENERAL.AED",
              })} ${formatFloatValue(
                overallResults.totalServiceCharges
              )} ${intl.formatMessage({
                id: "GENERAL.PER_SQ_FT",
              })} (${commaSeparateFormat(
                overallResults.annualServiceCharges
              )} ${intl.formatMessage({
                id: "GENERAL.PER_YEAR_APPROX",
              })})`}
            </StyleTypography>
          </Grid>
        ) : null}
        {overallResults?.views ? (
          <Grid item xs={6} md={"auto"} className="property--info">
            <StyleTooltip
              arrow
              className="property--icon"
              title={intl.formatMessage({ id: "GENERAL.VIEWS" })}
            >
              <Typography component="span">
                <SvgIcon name="views" />
              </Typography>
            </StyleTooltip>
            <StyleTypography className="property--text">
              {overallResults.views}
            </StyleTypography>
          </Grid>
        ) : null}
        {overallResults?.upgradesName ? (
          <Grid item xs={6} md={"auto"} className="property--info">
            <StyleTooltip
              arrow
              className="property--icon"
              title={intl.formatMessage({ id: "GENERAL.UPGRADES" })}
            >
              <Typography component="span">
                <SvgIcon name="upgrades" />
              </Typography>
            </StyleTooltip>
            <StyleTypography className="property--text">
              {overallResults.upgradesName}
            </StyleTypography>
          </Grid>
        ) : null}
      </Grid>
      <Grid
        container
        spacing={0}
        className="avm--values--wrapper"
        alignItems="center"
        justifyContent="space-between"
      >
        <Grid item xs={12} md={9}>
          <Grid container spacing={3}>
            <Grid item className="avm--price" xs={12}>
              <StyleTypography color="primary">
                {intl.formatMessage({
                  id: overallResults.finalValuationWithUpgrade
                    ? "RESULT.VALUATION_PRICE_WITH_UPGRADES"
                    : "RESULT.VALUATION_PRICE",
                })}
                <StyleTooltipMessage
                  title={
                    <>
                      <Typography>
                        {intl.formatMessage({
                          id: "EXPLANATION_ESTIMATED_VALUE",
                        })}
                      </Typography>
                    </>
                  }
                  arrow
                >
                  <IconButton className="tooltip--icon">
                    <SvgIcon name="info" />
                  </IconButton>
                </StyleTooltipMessage>
              </StyleTypography>
              <Typography color="primary" variant="h2">
                {`${intl.formatMessage({
                  id: "GENERAL.AED",
                })} `}
                {commaSeparateFormat(
                  overallResults.finalValuationWithUpgrade
                    ? overallResults.finalValuationWithUpgrade
                    : overallResults.finalValuation
                )}
              </Typography>
              {overallResults.finalValuationWithUpgrade ? (
                <StyleInfoTypography variant="h6">
                  {`${intl.formatMessage({
                    id: "RESULT.VALUATION_PRICE_WITHOUT_UPGRADES",
                  })} ${intl.formatMessage({
                    id: "GENERAL.AED",
                  })} `}
                  {commaSeparateFormat(overallResults.finalValuation)}
                </StyleInfoTypography>
              ) : null}
            </Grid>
            <Grid item className="avm--value--divider" xs={12}>
              <hr />
            </Grid>
            <Grid item className="avm--price" xs={12}>
              <StyleTypography color="primary">
                {intl.formatMessage({
                  id:
                    overallResults.finalValuationWithUpgradeHighEnd &&
                      overallResults.finalValuationWithUpgradeLowerEnd
                      ? "RESULT.VALUATION_PRICE_RANGE_WITH_UPGRADES"
                      : "RESULT.VALUATION_PRICE_RANGE",
                })}
                <StyleTooltipMessage
                  title={
                    <>
                      <Typography>
                        {intl.formatMessage({
                          id: "EXPLANATION_RANGE",
                        })}
                      </Typography>
                    </>
                  }
                  arrow
                >
                  <IconButton className="tooltip--icon">
                    <SvgIcon name="info" />
                  </IconButton>
                </StyleTooltipMessage>
              </StyleTypography>
              {overallResults.finalValuationWithUpgradeHighEnd &&
                overallResults.finalValuationWithUpgradeLowerEnd ? (
                <Typography color="primary" variant={DEVICE_WIDTH <= IS_MOBILE_WIDTH ? "h5" : "h3"}>
                  {`${intl.formatMessage({
                    id: "GENERAL.AED",
                  })} `}
                  {`${commaSeparateFormat(
                    overallResults.finalValuationWithUpgradeLowerEnd
                  )} `}
                  {`- ${intl.formatMessage({
                    id: "GENERAL.AED",
                  })} `}
                  {commaSeparateFormat(
                    overallResults.finalValuationWithUpgradeHighEnd
                  )}
                </Typography>
              ) : (
                <Typography color="primary" variant={DEVICE_WIDTH <= IS_MOBILE_WIDTH ? "h5" : "h3"}>
                  {`${intl.formatMessage({
                    id: "GENERAL.AED",
                  })} `}
                  {`${commaSeparateFormat(
                    overallResults.finalValuationLowerEnd
                  )} `}
                  {`- ${intl.formatMessage({
                    id: "GENERAL.AED",
                  })} `}
                  {commaSeparateFormat(overallResults.finalValuationHighEnd)}
                </Typography>
              )}
              {overallResults.finalValuationWithUpgradeHighEnd &&
                overallResults.finalValuationWithUpgradeLowerEnd ? (
                <StyleInfoTypography variant="h6">
                  {`${intl.formatMessage({
                    id: "RESULT.VALUATION_PRICE_RANGE_WITHOUT_UPGRADES",
                  })} `}
                  {`${intl.formatMessage({
                    id: "GENERAL.AED",
                  })} `}
                  {`${commaSeparateFormat(
                    overallResults.finalValuationLowerEnd
                  )} `}
                  {`- ${intl.formatMessage({
                    id: "GENERAL.AED",
                  })} `}
                  {commaSeparateFormat(overallResults.finalValuationHighEnd)}
                </StyleInfoTypography>
              ) : null}
            </Grid>
          </Grid>
        </Grid>

        {DEVICE_WIDTH <= IS_MOBILE_WIDTH ? (
          <Grid item className="meter-bar-wrapper" xs={12} md={3}>
            <div className="meter-bar">
              <div
                className={`bar-pointer ${overallResults.confidenceBand.toLowerCase()}`}
              >
                <SvgIcon name="pointer" />
              </div>

            </div>
            <div className="score-value">
              <StyleTypography color="primary">
                {intl.formatMessage({
                  id: "RESULT.CONFIDENCE_LEVEL",
                })}
                <StyleTooltipMessage
                  title={
                    <>
                      <Typography>
                        {intl.formatMessage({
                          id: "EXPLANATION_CONFIDENCE",
                        })}
                      </Typography>
                    </>
                  }
                  arrow
                >
                  <IconButton className="tooltip--icon">
                    <SvgIcon name="info" />
                  </IconButton>
                </StyleTooltipMessage>
              </StyleTypography>
              <Typography color="primary" variant="h3">
                {overallResults.confidenceLevel}
              </Typography>
            </div>
          </Grid>
        ) : (
          <Grid item className="score--meter" xs={12} md={3}>
            <div className="speedometer">
              <CardMedia component="img" image={Speedometer} />
              <div
                className={`score--pin ${overallResults.confidenceBand.toLowerCase()}`}
              >
                <SvgIcon name="speedometer-pin-2" />
              </div>
            </div>
            <div className="score-value">
              <StyleTypography color="primary">
                {intl.formatMessage({
                  id: "RESULT.CONFIDENCE_LEVEL",
                })}
                <StyleTooltipMessage
                  title={
                    <>
                      <Typography>
                        {intl.formatMessage({
                          id: "EXPLANATION_CONFIDENCE",
                        })}
                      </Typography>
                    </>
                  }
                  arrow
                >
                  <IconButton className="tooltip--icon">
                    <SvgIcon name="info" />
                  </IconButton>
                </StyleTooltipMessage>
              </StyleTypography>
              <Typography color="primary" variant="h3">
                {overallResults.confidenceLevel}
              </Typography>
            </div>
          </Grid>
        )}

        {valPriceRange &&
          valPriceRange?.low_transaction_price &&
          valPriceRange?.high_transaction_price ? (
          <Grid item xs={12} className="note--high--low--value">
            <StyleAlert variant="filled" severity="info">
              {parseInt(valPriceRange?.low_transaction_price) ===
                parseInt(valPriceRange?.high_transaction_price)
                ? intl.formatMessage(
                  {
                    id: "RESULT.MESSAGE.VALUE_NOTE_2",
                  },
                  {
                    low: commaSeparateFormat(
                      valPriceRange?.low_transaction_price
                    ),
                  }
                )
                : intl.formatMessage(
                  {
                    id: "RESULT.MESSAGE.VALUE_NOTE_1",
                  },
                  {
                    low: commaSeparateFormat(
                      valPriceRange?.low_transaction_price
                    ),
                    high: commaSeparateFormat(
                      valPriceRange?.high_transaction_price
                    ),
                  }
                )}
            </StyleAlert>
          </Grid>
        ) : null}
      </Grid>
      <Grid
        container
        spacing={3}
        justifyContent="flex-end"
        className="update--button--wrapper"
      >
        <Grid item xs={5} md={"auto"} align="right">
          <StyleButtonLarge
            variant="contained"
            color="secondary"
            size="large"
            onClick={() => {
              const trackParams = {
                event: "button-click",
                action: "back",
                status: "success",
                context: "avm-result",
                currentSession,
                userId: currentUser?.user_id || "",
                userConsumerId: currentUser?.userConsumerId || "",
              };
              _trackActivity(trackParams);
              if (!feedbackDone && !bottomScrollSeen) {
                showFeedbackWidget("result", "newAvmClick");
                setBottomScrollSeen(false);
              } else {
                goBack();
              }
            }}
          >
            {intl.formatMessage({ id: "GENERAL.NEW_AVM" })}
          </StyleButtonLarge>
        </Grid>
        <Grid item xs={7} md={"auto"} align="right">
          <StyleButtonLarge
            variant="contained"
            color="secondary"
            size="large"
            onClick={() => {
              if (!feedbackDone && !bottomScrollSeen) {
                showFeedbackWidget("result", "updateAvmClick");
                setBottomScrollSeen(false);
              } else {
                doUpdate();
              }
            }}
          >
            {intl.formatMessage({ id: "GENERAL.UPDATE_FILTER" })}
          </StyleButtonLarge>
        </Grid>
        <Grid item xs={12} md={"auto"} align="right">
          <StyleButtonLarge
            variant="contained"
            color="secondary"
            size="large"
            onClick={() => {
              const reportHash = overallResults?.reportHash || "";
              downloadReport(reportHash);
            }}
            // disabled={downloadReportDisabled}
            className="btn--loader"
          >
            {intl.formatMessage({ id: "GENERAL.DOWNLOAD_REPORT" })}
            {/* {downloadReportDisabled ? (
              <StyleWhiteCircularProgress color="primary" size={24} />
            ) : null} */}
          </StyleButtonLarge>
        </Grid>
      </Grid>
      {showComparables && (
        <Comparables
          comparables={overallResults.comparableData}
          addressLength={addressLength}
          pricePerSqftData={overallResults.pricePerSqftData}
          activeListings={overallResults.activeListingData}
        />
      )}
      {showCharts && (
        <IndexAndVolume
          overallResults={overallResults}
          reportHash={reportHash}
        // setDownloadReportDisabled={setDownloadReportDisabled}
        />
      )}
      {showSoldProperties && (
        <SoldProperties
          overallResults={overallResults}
          reportHash={reportHash}
        />
      )}
      {showAbout && (
        <AboutProperty
          overallResults={overallResults}
          reportHash={reportHash}
        />
      )}
      <TermsAndConditions />
    </div>
  );
};

export default injectIntl(AvmResult);
